<app-domain-navigation [domains]="domains">
    <ng-template let-data>
        <app-subdomain-summary [domain]="data.domain" [subdomain]="data.subdomain"
            [isActive]="data.subdomain.Value === currentRubricComponent" [isFocusArea]="isFocusArea(data.subdomain)"
            [readonly]="readOnly || !isTargetUser" (onClick)="onDomainNavigationClick($event)" [showFocusAreas]="true"
            (onClickFocus)="onComponentFocusClick($event)">
        </app-subdomain-summary>
    </ng-template>
</app-domain-navigation>

<app-rubric-domain-filter [filterType]="filterType" [includeFocusAreasFilter]="true">
</app-rubric-domain-filter>

<hr />
<div class="form-title">
    <div class="row">
        <div class="col-6">
            <h2>Evidence</h2>
        </div>
        <div class="col-6">
            <div class="text-end">
                <paetep-notify-of-comment *ngIf="canNotifyOfComment()" class="me-2"
                    [observationType]="ObservationTypeValues.NTPE"
                    [observationId]="observationDetails?.ntpeObservationId"
                    [observationTargetUserId]="observationDetails?.targetUserId"
                    [receivingUserIds]="isTargetUser ? [observationDetails?.evaluatingUserId] : isSupervisor ? [observationDetails?.targetUserId] : [observationDetails?.evaluatingUserId, observationDetails?.targetUserId]"></paetep-notify-of-comment>
                <paetep-publish-all-comments-button *ngIf="!observationDetails?.permissions?.actionPlan?.canSubmit"
                    class="me-2"></paetep-publish-all-comments-button>
                <button *ngIf="observationDetails?.permissions?.actionPlan?.canSubmit && isTargetUser" type="submit"
                    (click)="onSubmit()" class="btn btn-primary submit-button me-2 float-end"><i
                        class="far fa-save"></i> Submit</button>
                <button *ngIf="observationDetails?.permissions?.actionPlan?.canSubmit && isSupervisor" type="submit"
                    (click)="onApprove()" class="btn btn-primary submit-button me-2 float-end"><i
                        class="far fa-save"></i> Submit</button>
                <button *ngIf="!readOnly && (permissions?.canSave ?? false)" type="button" (click)="onSaveClick(form)"
                    class="btn btn-secondary me-2 float-end"><i class="fas fa-save"></i> Save</button>


            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            Select your component focus areas by clicking the star icons above. For each focus area, add a comment and
            explain your action plan for improving your practice in that area. Submit to your supervisor when finished.
        </div>
    </div>
</div>

<br />
<app-subdomains-display [domains]="domains" [filterType]="filterType" [currentSubdomain]="currentRubricComponent"
    [focusAreas]="focusAreas">
    <ng-template let-data>
        <div class="card secondary" id="{{data.subdomain?.Value}}">
            <div class="card-header text-white bg-secondary">
                <div class="d-flex flex-row justify-content-between">
                    <h5 class="mb-0">{{data?.subdomain?.Key}}. {{data?.subdomain?.LongLabel}}</h5>
                    <div class="text-end no-wrap">
                        <a class="text-white" [href]="rubricLanguageLink" target="_blank">View Rubric Language</a>
                        <edl-tooltip [icon]="EdlTooltipIcon.INFO" help="Under Act 13, the frameworks have been refreshed. The language has been revised and Discussion Prompts and Evidence of Practice have been added. Due to Copyright permissions the specific language is not embedded in the rubric assessment tool.  Click the View Rubric Language link to reference, download, and/or print the refreshed frameworks."></edl-tooltip>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <app-observation-comments [observationType]="observationType" [observationSummary]="observationSummary"
                    [defaultDomainFilterId]="data.subdomain?.Value" [hideFilter]="true"
                    [isReadOnly]="readOnly || (observationDetails?.completed ?? false)"
                    [attachmentLabel]="'Rubric ' +data.subdomain?.Value"
                    [initEditModePolicy]="InitializeEditModePolicy.OPEN_NEW_COMMENT_IF_NO_COMMENTS"
                    [isCommentCollapsed]="filterType !== DomainFilterType.COMPONENT && filterType !== DomainFilterType.FOCUS_AREAS"></app-observation-comments>
            </div>
        </div>
    </ng-template>
</app-subdomains-display>